import React, { useState, useEffect, useMemo } from 'react';
import DashboardTabSwitcher from '../../../ui/DashboardTabSwitcher';
import DashboardMetricCard from '../../../ui/DashboardMetricCard';
import DashboardListCard from '../../../ui/DashboardListCard';
import {
    ParticipantsIcon,
    ActivitiesIcon,
    FundsIcon,
    ImpactCertificatesIcon,
    CodeIcon,
    SurveyIcon,
    ScoutingIcon,
    HarvestIcon,
    VolunteerIcon,
    UserAvatarIcon
} from '../../../assets/icons/DashboardIcons';

// Import individual tab components
import OverallTab from './tabs/OverallTab';
import ActivitiesTab from './tabs/ActivitiesTab';
import ActivityTypesTab from './tabs/ActivityTypesTab';
import ImpactCertificatesTab from './tabs/ImpactCertificatesTab';
import SDGsTab from './tabs/SDGsTab';
import LocationTab from './tabs/LocationTab';
import ContributionTab from './tabs/ContributionTab';
import FundsTab from './tabs/FundsTab';
import { prefetch } from '../../../hooks/useFetchData';
import { getOverallTabData, getProjectStatistics } from '../../../apis/impact-report/report';
import { FiltersProvider, useFilters } from '../../../contexts/FiltersContext';
import { useParams } from 'react-router-dom';

const tabs = [
    { label: 'Overall', value: 'overall',isFilterRequired:false },
    { label: 'Activities', value: 'activities',isFilterRequired:true },
    { label: 'Activity Types', value: 'activity-types',isFilterRequired:true },
    { label: 'Impact Certificates', value: 'impact-certificates',isFilterRequired:true },
    { label: 'SDGs', value: 'sdgs',isFilterRequired:true },
    { label: 'Location', value: 'location',isFilterRequired:true },
    { label: 'Contribution', value: 'contribution',isFilterRequired:true },
    { label: 'Funds', value: 'funds',isFilterRequired:true }
];


const ProjectDashboardInner = ({projectId,imageGenerationTimestamp}) => {
    const [activeTab, setActiveTab] = useState('overall');
    const [isFading, setIsFading] = useState(false);
    const [isShowFilter,setIsShowFilter] = useState(false)
   

    const { setFilterOptions, setSelectedPrimary } = useFilters()
console.log(projectId,"see this is the projectId")
    useEffect(()=>{
        switch (activeTab) {
            case 'activities':
                setFilterOptions({ label: 'Activities', options: [] });
                setSelectedPrimary(['All'])
                break;
            case 'activity-types':
                setFilterOptions({ label: 'Activity Types', options: [] });
                setSelectedPrimary(['All'])
                break;
            case 'impact-certificates':
                setFilterOptions({ label: 'Activities', options: [] });
                setSelectedPrimary(['All'])
                break;
            case 'sdgs':
                setFilterOptions({ label: 'SDGs', options: [] });
                setSelectedPrimary(['All'])
                break;
            case 'contribution':
                setFilterOptions({ label: 'Contribution Types', options: ['Participated','Created','Validated'] });
                setSelectedPrimary(['All'])
                break;
            case 'funds':
                setFilterOptions({ label: 'Activities', options: [] });
                setSelectedPrimary(['All'])
                break;
            default:
                setFilterOptions({ label: 'Filter', options: [] });
                setSelectedPrimary(['All'])
        }
    },[activeTab, setFilterOptions, setSelectedPrimary])

    // Warm cache so tabs render instantly without loaders
    // useEffect(() => {
    //     // const projectId = '685e8d68d330b48701af878e';
    //     prefetch(getOverallTabData, [projectId]).catch(() => {});
    //     prefetch(getProjectStatistics, [projectId, 'BOUNTY_WISE_SUBMISSION_COUNT', '', '']).catch(() => {});
    // }, []);

    const handleTabChange = (tabValue,isFilterRequired) => {
        if (tabValue === activeTab) return;
        setIsFading(true);
        setTimeout(() => {
            setIsShowFilter(isFilterRequired)
            setActiveTab(tabValue);
            setIsFading(false);
        }, 120);
    };

    const handleShare = () => {
        console.log('Sharing project dashboard... ');
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'overall':
                return <OverallTab projectId={projectId} imageGenerationTimestamp={imageGenerationTimestamp} />;
            case 'activities':
                return <ActivitiesTab projectId={projectId}  imageGenerationTimestamp={imageGenerationTimestamp}  />;
            case 'activity-types':
                return <ActivityTypesTab projectId={projectId} imageGenerationTimestamp={imageGenerationTimestamp} />;
            case 'impact-certificates':
                return <ImpactCertificatesTab projectId={projectId} imageGenerationTimestamp={imageGenerationTimestamp} />;
            case 'sdgs':
                return <SDGsTab projectId={projectId}  imageGenerationTimestamp={imageGenerationTimestamp} />;
            case 'location':
                return <LocationTab projectId={projectId} imageGenerationTimestamp={imageGenerationTimestamp} />;
            case 'contribution':
                return <ContributionTab projectId={projectId} imageGenerationTimestamp={imageGenerationTimestamp} />;
            case 'funds':
                return <FundsTab projectId={projectId} imageGenerationTimestamp={imageGenerationTimestamp} />;
            default:
                return <OverallTab projectId={projectId} imageGenerationTimestamp={imageGenerationTimestamp}  />;
        }
    };
console.log(projectId,"dekho project ido k")
    return (
        <div className=" bg-grayBgNormal shadow-custom-multi rounded-lg px-6 py-5">
            <div className="max-w-7xl mx-auto">
                <DashboardTabSwitcher
                    tabs={tabs}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                    onShare={handleShare}
                    showFilter={isShowFilter}
                >
                    <div className={`transition-opacity duration-200 ${isFading ? 'opacity-0' : 'opacity-100'}`}>
                        {renderTabContent()}
                    </div>
                </DashboardTabSwitcher>
            </div>
        </div>
    );
};

const ProjectDashboard = ({projectId,imageGenerationTimestamp}) => {
    return (
        <FiltersProvider>
            <ProjectDashboardInner projectId={projectId} imageGenerationTimestamp={imageGenerationTimestamp}/>
        </FiltersProvider>
    )
}

export default ProjectDashboard; 